import { Translations } from './index';

export const translations: Translations = {
  // Common UI elements
  'common.loading': {
    fr: 'Chargement...',
    en: 'Loading...'
  },
  'common.save': {
    fr: 'Enregistrer',
    en: 'Save'
  },
  'common.cancel': {
    fr: 'Annuler',
    en: 'Cancel'
  },
  'common.edit': {
    fr: 'Modifier',
    en: 'Edit'
  },
  'common.delete': {
    fr: 'Supprimer',
    en: 'Delete'
  },
  'common.view': {
    fr: 'Voir',
    en: 'View'
  },
  'common.close': {
    fr: 'Fermer',
    en: 'Close'
  },
  'common.back': {
    fr: 'Retour',
    en: 'Back'
  },
  'common.next': {
    fr: 'Suivant',
    en: 'Next'
  },
  'common.previous': {
    fr: 'Précédent',
    en: 'Previous'
  },
  'common.search': {
    fr: 'Rechercher',
    en: 'Search'
  },
  'common.filter': {
    fr: 'Filtrer',
    en: 'Filter'
  },
  'common.export': {
    fr: 'Exporter',
    en: 'Export'
  },
  'common.import': {
    fr: 'Importer',
    en: 'Import'
  },
  'common.download': {
    fr: 'Télécharger',
    en: 'Download'
  },
  'common.upload': {
    fr: 'Télécharger',
    en: 'Upload'
  },
  'common.transactionType': {
    fr: 'Type de transaction',
    en: 'Transaction Type'
  },
  'common.allTypes': {
    fr: 'Tous les types',
    en: 'All Types'
  },
  'common.startDate': {
    fr: 'Date de début',
    en: 'Start Date'
  },
  'common.endDate': {
    fr: 'Date de fin',
    en: 'End Date'
  },
  'common.viewDetails': {
    fr: 'Voir les détails',
    en: 'View Details'
  },
  'common.transactionId': {
    fr: 'ID de transaction',
    en: 'Transaction ID'
  },
  'common.loanId': {
    fr: 'ID du prêt',
    en: 'Loan ID'
  },
  'common.type': {
    fr: 'Type',
    en: 'Type'
  },
  'common.amount': {
    fr: 'Montant',
    en: 'Amount'
  },
  'common.date': {
    fr: 'Date',
    en: 'Date'
  },
  'common.status': {
    fr: 'Statut',
    en: 'Status'
  },
  'common.reference': {
    fr: 'Référence',
    en: 'Reference'
  },
  'common.actions': {
    fr: 'Actions',
    en: 'Actions'
  },
  'common.transactions': {
    fr: 'transactions',
    en: 'transactions'
  },
  'common.exportXLS': {
    fr: 'Exporter XLS',
    en: 'Export XLS'
  },
  'common.exportPDF': {
    fr: 'Exporter PDF',
    en: 'Export PDF'
  },
  'common.yes': {
    fr: 'Oui',
    en: 'Yes'
  },
  'common.no': {
    fr: 'Non',
    en: 'No'
  },
  'common.confirm': {
    fr: 'Confirmer',
    en: 'Confirm'
  },
  'common.required': {
    fr: 'Requis',
    en: 'Required'
  },
  'common.optional': {
    fr: 'Optionnel',
    en: 'Optional'
  },
  'common.error': {
    fr: 'Erreur',
    en: 'Error'
  },
  'common.success': {
    fr: 'Succès',
    en: 'Success'
  },
  'common.warning': {
    fr: 'Avertissement',
    en: 'Warning'
  },
  'common.info': {
    fr: 'Information',
    en: 'Information'
  },

  // Navigation
  'nav.dashboard': {
    fr: 'Tableau de bord',
    en: 'Dashboard'
  },
  'nav.applicationStatus': {
    fr: 'Statut des demandes',
    en: 'Application Status'
  },
  'nav.transactionDetails': {
    fr: 'Détails des transactions',
    en: 'Transaction Details'
  },
  'nav.reports': {
    fr: 'Rapports',
    en: 'Reports'
  },
  'nav.auditLog': {
    fr: 'Journal d\'audit',
    en: 'Audit Log'
  },
  'nav.rulesManagement': {
    fr: 'Gestion des règles',
    en: 'Rules Management'
  },
  'nav.apiDocs': {
    fr: 'Documentation API',
    en: 'API Docs'
  },
  'nav.applicationDetails': {
    fr: 'Détails de la demande',
    en: 'Application Details'
  },
  'nav.settingsTooltip': {
    fr: 'Paramètres',
    en: 'Settings'
  },
  'nav.logoutTooltip': {
    fr: 'Déconnexion',
    en: 'Logout'
  },
  'nav.userRole': {
    fr: 'Rôle',
    en: 'Role'
  },
  'nav.settings': {
    fr: 'Paramètres',
    en: 'Settings'
  },
  'nav.profile': {
    fr: 'Profil',
    en: 'Profile'
  },
  'nav.logout': {
    fr: 'Déconnexion',
    en: 'Logout'
  },
  'nav.merchants': {
    fr: 'Marchands',
    en: 'Merchants'
  },
  'nav.bank': {
    fr: 'Banque',
    en: 'Bank'
  },
  'nav.wave': {
    fr: 'Wave',
    en: 'Wave'
  },
  // Privileges labels
  'priv.action.create': { fr: 'créer', en: 'create' },
  'priv.action.read': { fr: 'lire', en: 'read' },
  'priv.action.update': { fr: 'mettre à jour', en: 'update' },
  'priv.action.delete': { fr: 'supprimer', en: 'delete' },
  'priv.resource.applications': { fr: 'demandes', en: 'applications' },
  'priv.resource.reports': { fr: 'rapports', en: 'reports' },
  'priv.resource.rules': { fr: 'règles', en: 'rules' },
  'priv.resource.users': { fr: 'utilisateurs', en: 'users' },
  'priv.resource.merchants': { fr: 'marchands', en: 'merchants' },
  'priv.resource.transactions': { fr: 'transactions', en: 'transactions' },
  'priv.resource.settings': { fr: 'paramètres', en: 'settings' },
  'priv.resource.teams': { fr: 'équipes', en: 'teams' },

  // Dashboard
  'dashboard.welcome': {
    fr: 'Bienvenue !',
    en: 'Welcome!'
  },
  'dashboard.overview': {
    fr: 'Aperçu de votre portefeuille de prêts',
    en: 'Here\'s a quick overview of your loan portfolio'
  },
  'dashboard.totalApplications': {
    fr: 'Total des demandes',
    en: 'Total Applications'
  },
  'dashboard.approved': {
    fr: 'Approuvées',
    en: 'Approved'
  },
  'dashboard.rejected': {
    fr: 'Rejetées',
    en: 'Rejected'
  },
  'dashboard.approvalRate': {
    fr: 'Taux d\'approbation',
    en: 'Approval Rate'
  },
  'dashboard.portfolioRisk': {
    fr: 'Distribution des risques du portefeuille',
    en: 'Portfolio Risk Distribution'
  },
  'dashboard.applicationStatus': {
    fr: 'Statut des demandes',
    en: 'Application Status'
  },
  'dashboard.recentApplications': {
    fr: 'Demandes récentes',
    en: 'Recent Applications'
  },

  // KPI Cards
  'kpi.totalDisbursed': {
    fr: 'Total décaissé',
    en: 'Total Disbursed'
  },
  'kpi.totalRepaid': {
    fr: 'Total remboursé',
    en: 'Total Repaid'
  },
  'kpi.loanApplications': {
    fr: 'Demandes de prêt',
    en: 'Loan Applications'
  },
  'kpi.rejected': {
    fr: 'Rejetées',
    en: 'Rejected'
  },
  'kpi.approved': {
    fr: 'Approuvées',
    en: 'Approved'
  },
  'kpi.overdue': {
    fr: 'En retard',
    en: 'Overdue'
  },
  'kpi.clickForDetails': {
    fr: 'Cliquer pour les détails',
    en: 'Click for details'
  },
  'kpi.vsPrevPeriod': {
    fr: 'vs période précédente',
    en: 'vs prev period'
  },

  // Application Status
  'status.pending': {
    fr: 'En attente',
    en: 'Pending'
  },
  'status.approved': {
    fr: 'Approuvée',
    en: 'Approved'
  },
  'status.rejected': {
    fr: 'Rejetée',
    en: 'Rejected'
  },
  'status.underReview': {
    fr: 'En cours d\'examen',
    en: 'Under Review'
  },
  'status.completed': {
    fr: 'Terminée',
    en: 'Completed'
  },
  'status.cancelled': {
    fr: 'Annulée',
    en: 'Cancelled'
  },

  // Forms
  'form.applicantName': {
    fr: 'Nom du demandeur',
    en: 'Applicant Name'
  },
  'form.nationalId': {
    fr: 'Identifiant national',
    en: 'National ID'
  },
  'form.phoneNumber': {
    fr: 'Numéro de téléphone',
    en: 'Phone Number'
  },
  'form.email': {
    fr: 'Adresse e-mail',
    en: 'Email Address'
  },
  'form.address': {
    fr: 'Adresse',
    en: 'Address'
  },
  'form.requestedAmount': {
    fr: 'Montant demandé',
    en: 'Requested Amount'
  },
  'form.loanPurpose': {
    fr: 'Objet du prêt',
    en: 'Loan Purpose'
  },
  'form.submissionDate': {
    fr: 'Date de soumission',
    en: 'Submission Date'
  },
  'form.creditScore': {
    fr: 'Score de crédit',
    en: 'Credit Score'
  },
  'form.customerType': {
    fr: 'Type de client',
    en: 'Customer Type'
  },
  'form.merchantId': {
    fr: 'ID du marchand',
    en: 'Merchant ID'
  },

  // Customer Types
  'customerType.individual': {
    fr: 'Individuel',
    en: 'Individual'
  },
  'customerType.sme': {
    fr: 'PME',
    en: 'SME'
  },
  'customerType.corporate': {
    fr: 'Entreprise',
    en: 'Corporate'
  },

  // Loan Purposes
  'loanPurpose.business': {
    fr: 'Affaires',
    en: 'Business'
  },
  'loanPurpose.personal': {
    fr: 'Personnel',
    en: 'Personal'
  },
  'loanPurpose.education': {
    fr: 'Éducation',
    en: 'Education'
  },
  'loanPurpose.health': {
    fr: 'Santé',
    en: 'Health'
  },
  'loanPurpose.agriculture': {
    fr: 'Agriculture',
    en: 'Agriculture'
  },

  // Charts and Reports
  'chart.dailyLoanActivities': {
    fr: 'Activités quotidiennes de prêt',
    en: 'Daily Loan Activities'
  },
  'chart.disbursements': {
    fr: 'Décaissements',
    en: 'Disbursements'
  },
  'chart.repayments': {
    fr: 'Remboursements',
    en: 'Repayments'
  },
  'chart.topMerchants': {
    fr: 'Meilleurs marchands par décaissements',
    en: 'Top Merchants by Loan Disbursements'
  },
  'chart.nonPerformingLoans': {
    fr: 'Prêts non performants',
    en: 'Non-Performing Loans'
  },
  'chart.portfolioRisk': {
    fr: 'Distribution des risques du portefeuille',
    en: 'Portfolio Risk Distribution'
  },
  'chart.creditScoreDistribution': {
    fr: 'Distribution des scores de crédit',
    en: 'Credit Score Distribution'
  },

  // Risk Levels
  'risk.low': {
    fr: 'Faible',
    en: 'Low'
  },
  'risk.medium': {
    fr: 'Moyen',
    en: 'Medium'
  },
  'risk.high': {
    fr: 'Élevé',
    en: 'High'
  },
  'risk.critical': {
    fr: 'Critique',
    en: 'Critical'
  },

  // Time Periods
  'time.days': {
    fr: 'jours',
    en: 'days'
  },
  'time.weeks': {
    fr: 'semaines',
    en: 'weeks'
  },
  'time.months': {
    fr: 'mois',
    en: 'months'
  },
  'time.years': {
    fr: 'années',
    en: 'years'
  },

  // Messages
  'message.noData': {
    fr: 'Aucune donnée disponible',
    en: 'No data available'
  },
  'message.loading': {
    fr: 'Chargement en cours...',
    en: 'Loading...'
  },
  'message.error': {
    fr: 'Une erreur s\'est produite',
    en: 'An error occurred'
  },
  'message.success': {
    fr: 'Opération réussie',
    en: 'Operation successful'
  },
  'message.confirmDelete': {
    fr: 'Êtes-vous sûr de vouloir supprimer cet élément ?',
    en: 'Are you sure you want to delete this item?'
  },

  // Language Switcher
  'language.switch': {
    fr: 'Changer de langue',
    en: 'Change Language'
  },
  'language.french': {
    fr: 'Français',
    en: 'French'
  },
  'language.english': {
    fr: 'Anglais',
    en: 'English'
  },
  'language.current': {
    fr: 'Langue actuelle',
    en: 'Current Language'
  },

  // Settings
  'settings.language': {
    fr: 'Langue',
    en: 'Language'
  },
  'settings.currency': {
    fr: 'Devise',
    en: 'Currency'
  },
  'settings.timezone': {
    fr: 'Fuseau horaire',
    en: 'Timezone'
  },
  'settings.notifications': {
    fr: 'Notifications',
    en: 'Notifications'
  },
  'settings.security': {
    fr: 'Sécurité',
    en: 'Security'
  },

  // Currency
  'currency.xof': {
    fr: 'ZiG (Zimbabwe Gold)',
    en: 'ZiG (Zimbabwe Gold)'
  },
  'currency.format': {
    fr: 'Format anglais',
    en: 'English format'
  },

  // Authentication
  'auth.login': {
    fr: 'Connexion',
    en: 'Login'
  },
  'auth.logout': {
    fr: 'Déconnexion',
    en: 'Logout'
  },
  'auth.username': {
    fr: 'Nom d\'utilisateur',
    en: 'Username'
  },
  'auth.password': {
    fr: 'Mot de passe',
    en: 'Password'
  },
  'auth.forgotPassword': {
    fr: 'Mot de passe oublié ?',
    en: 'Forgot Password?'
  },
  'auth.rememberMe': {
    fr: 'Se souvenir de moi',
    en: 'Remember Me'
  },

  // Bank Dashboard
  'bank.dashboard.title': {
    fr: 'Tableau de bord FinScore AI',
    en: 'FinScore AI Dashboard'
  },
  'bank.dashboard.subtitle': {
    fr: 'Surveillance complète du portefeuille avec insights en temps réel et gestion des risques',
    en: 'Complete portfolio oversight with real-time insights and risk management'
  },
  'bank.totalLoans': {
    fr: 'Total des prêts',
    en: 'Total Loans'
  },
  'bank.repaymentRate': {
    fr: 'Taux de remboursement',
    en: 'Repayment Rate'
  },
  'bank.nonPerformingLoans': {
    fr: 'Prêts non performants',
    en: 'Non-Performing Loans'
  },
  'bank.viewDetails': {
    fr: 'Voir les détails',
    en: 'View Details'
  },
  'bank.earlyWarning': {
    fr: 'Système d\'alerte précoce',
    en: 'Early Warning System'
  },
  'bank.enterMerchantId': {
    fr: 'Entrer l\'ID du marchand',
    en: 'Enter Merchant ID'
  },
  'bank.analyze': {
    fr: 'Analyser',
    en: 'Analyze'
  },

  // Wave Dashboard
  'wave.dashboard.title': {
    fr: 'Tableau de bord WAVE',
    en: 'WAVE Dashboard'
  },
  'wave.exploreLoans': {
    fr: 'Explorer les prêts',
    en: 'Explore Loans'
  },
  'wave.applicationStatus': {
    fr: 'Statut et recherche des demandes',
    en: 'Application Status & Search'
  },
  'wave.transactions': {
    fr: 'Détails des décaissements et remboursements',
    en: 'Disbursement & Repayment Details'
  },

  // Merchant Dashboard
  'merchant.dashboard.title': {
    fr: 'Portail Marchand',
    en: 'Merchant Portal'
  },
  'merchant.dashboard.subtitle': {
    fr: 'Bienvenue. Suivez vos demandes de prêt et métriques de compte.',
    en: 'Welcome. Track your loan applications and account metrics.'
  },
  'merchant.totalDisbursed': {
    fr: 'Total décaissé',
    en: 'Total Disbursed'
  },
  'merchant.totalRepaid': {
    fr: 'Total remboursé',
    en: 'Total Repaid'
  },
  'merchant.loansSubmitted': {
    fr: 'Prêts soumis',
    en: 'Loans Submitted'
  },
  'merchant.approvalRate': {
    fr: 'Taux d\'approbation',
    en: 'Approval Rate'
  },
  'merchant.repaymentRate': {
    fr: 'Taux de remboursement',
    en: 'Repayment Rate'
  },
  'merchant.recentLoanActivities': {
    fr: 'Activités récentes de prêt',
    en: 'Recent Loan Activities'
  },
  'merchant.yourLoanApplications': {
    fr: 'Vos demandes de prêt',
    en: 'Your Loan Applications'
  },
  'merchant.noApplications': {
    fr: 'Aucune demande pour le moment.',
    en: 'No applications yet.'
  },
  'merchant.submitted': {
    fr: 'Soumis',
    en: 'Submitted'
  },
  'merchant.viewLifecycle': {
    fr: 'Voir le cycle de vie',
    en: 'View lifecycle'
  },

  // Reports
  'reports.title': {
    fr: 'Rapports d\'administration',
    en: 'Admin Reports'
  },
  'reports.applicationReports': {
    fr: 'Rapports de demandes',
    en: 'Application Reports'
  },
  'reports.systemReports': {
    fr: 'Rapports système',
    en: 'System Reports'
  },
  'reports.visualizations': {
    fr: 'Visualisations',
    en: 'Visualizations'
  },
  'reports.applicationStatusBreakdown': {
    fr: 'Répartition du statut des demandes',
    en: 'Application Status Breakdown'
  },
  'reports.creditScoreDistribution': {
    fr: 'Distribution des scores de crédit',
    en: 'Credit Score Distribution'
  },
  'reports.noApplications': {
    fr: 'Aucune demande trouvée.',
    en: 'No applications found.'
  },

  // Credit Bureau
  'creditBureau.title': {
    fr: 'Bureau de crédit',
    en: 'Credit Bureau'
  },
  'creditBureau.subtitle': {
    fr: 'Rapports de crédit complets, historique des paiements et évaluation des risques',
    en: 'Comprehensive credit reports, payment history, and risk assessment'
  },
  'creditBureau.generateReport': {
    fr: 'Générer un rapport de crédit',
    en: 'Generate Credit Report'
  },
  'creditBureau.enterApplicantEmail': {
    fr: 'Entrer l\'e-mail du demandeur',
    en: 'Enter applicant email'
  },
  'creditBureau.generateReportButton': {
    fr: 'Générer le rapport',
    en: 'Generate Report'
  },
  'creditBureau.creditScore': {
    fr: 'Score de crédit',
    en: 'Credit Score'
  },
  'creditBureau.paymentReliability': {
    fr: 'Fiabilité des paiements',
    en: 'Payment Reliability'
  },
  'creditBureau.creditUtilization': {
    fr: 'Utilisation du crédit',
    en: 'Credit Utilization'
  },
  'creditBureau.riskFactors': {
    fr: 'Facteurs de risque',
    en: 'Risk Factors'
  },
  'creditBureau.repaymentHistory': {
    fr: 'Historique des remboursements',
    en: 'Repayment History'
  },
  'creditBureau.dueDate': {
    fr: 'Date d\'échéance',
    en: 'Due Date'
  },
  'creditBureau.paymentDate': {
    fr: 'Date de paiement',
    en: 'Payment Date'
  },
  'creditBureau.amount': {
    fr: 'Montant',
    en: 'Amount'
  },
  'creditBureau.status': {
    fr: 'Statut',
    en: 'Status'
  },
  'creditBureau.daysLate': {
    fr: 'Jours de retard',
    en: 'Days Late'
  },
  'creditBureau.loanApplicationsHistory': {
    fr: 'Historique des demandes de prêt',
    en: 'Loan Applications History'
  },
  'creditBureau.noNonPerformingLoans': {
    fr: 'Aucun prêt non performant trouvé pour ce bucket.',
    en: 'No non-performing loans found for this bucket.'
  },
  'creditBureau.noLoanApplications': {
    fr: 'Aucune demande de prêt trouvée pour ce marchand.',
    en: 'No loan applications found for this merchant.'
  },

  // Portfolio Health
  'portfolioHealth.title': {
    fr: 'Santé du portefeuille de prêts',
    en: 'Loan Portfolio Health'
  },
  'portfolioHealth.totalPortfolioValue': {
    fr: 'Valeur totale du portefeuille',
    en: 'Total Portfolio Value'
  },
  'portfolioHealth.performingLoans': {
    fr: 'Prêts performants',
    en: 'Performing Loans'
  },
  'portfolioHealth.nonPerformingLoans': {
    fr: 'Prêts non performants',
    en: 'Non-Performing Loans'
  },
  'portfolioHealth.averageCreditScore': {
    fr: 'Score de crédit moyen',
    en: 'Average Credit Score'
  },
  'portfolioHealth.riskDistribution': {
    fr: 'Distribution des risques',
    en: 'Risk Distribution'
  },
  'portfolioHealth.monthlyTrends': {
    fr: 'Tendances mensuelles',
    en: 'Monthly Trends'
  },
  'portfolioHealth.repaymentSchedule': {
    fr: 'Échéancier de remboursement',
    en: 'Repayment Schedule'
  },
  'portfolioHealth.lowRisk': {
    fr: 'Risque faible',
    en: 'Low Risk'
  },
  'portfolioHealth.mediumRisk': {
    fr: 'Risque moyen',
    en: 'Medium Risk'
  },
  'portfolioHealth.highRisk': {
    fr: 'Risque élevé',
    en: 'High Risk'
  },

  // Transaction Reports
  'transactionReports.title': {
    fr: 'Rapports de transactions',
    en: 'Transaction Reports'
  },
  'transactionReports.totalDisbursements': {
    fr: 'Total des décaissements',
    en: 'Total Disbursements'
  },
  'transactionReports.totalRepayments': {
    fr: 'Total des remboursements',
    en: 'Total Repayments'
  },
  'transactionReports.totalFees': {
    fr: 'Total des frais',
    en: 'Total Fees'
  },
  'transactionReports.totalRefunds': {
    fr: 'Total des remboursements',
    en: 'Total Refunds'
  },
  'transactionReports.transactionDistribution': {
    fr: 'Distribution des transactions',
    en: 'Transaction Distribution'
  },
  'transactionReports.monthlyTrends': {
    fr: 'Tendances mensuelles',
    en: 'Monthly Trends'
  },
  'transactionReports.disbursements': {
    fr: 'Décaissements',
    en: 'Disbursements'
  },
  'transactionReports.repayments': {
    fr: 'Remboursements',
    en: 'Repayments'
  },
  'transactionReports.fees': {
    fr: 'Frais',
    en: 'Fees'
  },
  'transactionReports.refunds': {
    fr: 'Remboursements',
    en: 'Refunds'
  },
  'transactionReports.transactionDetails': {
    fr: 'Détails des transactions',
    en: 'Transaction Details'
  },
  'transactionReports.disbursement': {
    fr: 'Décaissement',
    en: 'Disbursement'
  },
  'transactionReports.repayment': {
    fr: 'Remboursement',
    en: 'Repayment'
  },
  'transactionReports.fee': {
    fr: 'Frais',
    en: 'Fee'
  },
  'transactionReports.refund': {
    fr: 'Remboursement',
    en: 'Refund'
  },
  'transactionReports.completed': {
    fr: 'Terminé',
    en: 'Completed'
  },
  'transactionReports.pending': {
    fr: 'En attente',
    en: 'Pending'
  },
  'transactionReports.refundRequests': {
    fr: 'Demandes de remboursement',
    en: 'Refund Requests'
  },
  'transactionReports.refundId': {
    fr: 'ID de remboursement',
    en: 'Refund ID'
  },
  'transactionReports.reason': {
    fr: 'Raison',
    en: 'Reason'
  },
  'transactionReports.requestDate': {
    fr: 'Date de demande',
    en: 'Request Date'
  },
  'transactionReports.processedBy': {
    fr: 'Traité par',
    en: 'Processed By'
  },
  'transactionReports.processed': {
    fr: 'Traité',
    en: 'Processed'
  },

  // Inactive Account Alerts
  'inactiveAlerts.title': {
    fr: 'Alertes de comptes inactifs',
    en: 'Inactive Account Alerts'
  },
  'inactiveAlerts.totalAlerts': {
    fr: 'Total des alertes',
    en: 'Total Alerts'
  },
  'inactiveAlerts.criticalAlerts': {
    fr: 'Alertes critiques',
    en: 'Critical Alerts'
  },
  'inactiveAlerts.warningAlerts': {
    fr: 'Alertes d\'avertissement',
    en: 'Warning Alerts'
  },
  'inactiveAlerts.accountsOver30Days': {
    fr: 'Comptes >30 jours',
    en: 'Accounts >30 Days'
  },
  'inactiveAlerts.accountType': {
    fr: 'Type de compte',
    en: 'Account Type'
  },
  'inactiveAlerts.riskLevel': {
    fr: 'Niveau de risque',
    en: 'Risk Level'
  },
  'inactiveAlerts.allTypes': {
    fr: 'Tous les types',
    en: 'All Types'
  },
  'inactiveAlerts.merchant': {
    fr: 'Marchand',
    en: 'Merchant'
  },
  'inactiveAlerts.loan': {
    fr: 'Prêt',
    en: 'Loan'
  },
  'inactiveAlerts.bank': {
    fr: 'Banque',
    en: 'Bank'
  },
  'inactiveAlerts.allLevels': {
    fr: 'Tous les niveaux',
    en: 'All Levels'
  },
  'inactiveAlerts.highRisk': {
    fr: 'Risque élevé',
    en: 'High Risk'
  },
  'inactiveAlerts.mediumRisk': {
    fr: 'Risque moyen',
    en: 'Medium Risk'
  },
  'inactiveAlerts.lowRisk': {
    fr: 'Risque faible',
    en: 'Low Risk'
  },
  'inactiveAlerts.processCriticalAlerts': {
    fr: 'Traiter les alertes critiques',
    en: 'Process Critical Alerts'
  },
  'inactiveAlerts.processWarningAlerts': {
    fr: 'Traiter les alertes d\'avertissement',
    en: 'Process Warning Alerts'
  },
  'inactiveAlerts.scheduledActions': {
    fr: 'Actions programmées',
    en: 'Scheduled Actions'
  },

  // Account Linking
  'accountLinking.title': {
    fr: 'Liaison de comptes Bank-Wave',
    en: 'Bank-to-Wave Account Linking'
  },
  'accountLinking.totalLinkedAccounts': {
    fr: 'Total des comptes liés',
    en: 'Total Linked Accounts'
  },
  'accountLinking.activeLinks': {
    fr: 'Liens actifs',
    en: 'Active Links'
  },
  'accountLinking.pendingLinks': {
    fr: 'Liens en attente',
    en: 'Pending Links'
  },
  'accountLinking.inactiveLinks': {
    fr: 'Liens inactifs',
    en: 'Inactive Links'
  },
  'accountLinking.linkNewAccount': {
    fr: 'Lier un nouveau compte',
    en: 'Link New Account'
  },
  'accountLinking.syncAllAccounts': {
    fr: 'Synchroniser tous les comptes',
    en: 'Sync All Accounts'
  },
  'accountLinking.refreshStatus': {
    fr: 'Actualiser le statut',
    en: 'Refresh Status'
  },
  'accountLinking.statusFilter': {
    fr: 'Filtre de statut',
    en: 'Status Filter'
  },
  'accountLinking.allStatuses': {
    fr: 'Tous les statuts',
    en: 'All Statuses'
  },
  'accountLinking.active': {
    fr: 'Actif',
    en: 'Active'
  },
  'accountLinking.pending': {
    fr: 'En attente',
    en: 'Pending'
  },
  'accountLinking.inactive': {
    fr: 'Inactif',
    en: 'Inactive'
  },
  'accountLinking.bankAccount': {
    fr: 'Compte bancaire',
    en: 'Bank Account'
  },
  'accountLinking.waveAccount': {
    fr: 'Compte Wave',
    en: 'Wave Account'
  },
  'accountLinking.merchantId': {
    fr: 'ID du marchand',
    en: 'Merchant ID'
  },
  'accountLinking.linkedDate': {
    fr: 'Date de liaison',
    en: 'Linked Date'
  },
  'accountLinking.lastSync': {
    fr: 'Dernière synchronisation',
    en: 'Last Sync'
  },
  'accountLinking.syncStatus': {
    fr: 'Statut de synchronisation',
    en: 'Sync Status'
  },
  'accountLinking.success': {
    fr: 'Succès',
    en: 'Success'
  },
  'accountLinking.failed': {
    fr: 'Échec',
    en: 'Failed'
  },
  'accountLinking.viewDetails': {
    fr: 'Voir les détails',
    en: 'View Details'
  },
  'accountLinking.editLink': {
    fr: 'Modifier le lien',
    en: 'Edit Link'
  },
  'accountLinking.syncAccount': {
    fr: 'Synchroniser le compte',
    en: 'Sync Account'
  },
  'accountLinking.unlinkAccount': {
    fr: 'Délier le compte',
    en: 'Unlink Account'
  },
  'accountLinking.linkNewBankWaveAccount': {
    fr: 'Lier un nouveau compte Bank-Wave',
    en: 'Link New Bank-to-Wave Account'
  },
  'accountLinking.bankAccountDetails': {
    fr: 'Détails du compte bancaire',
    en: 'Bank Account Details'
  },
  'accountLinking.waveAccountDetails': {
    fr: 'Détails du compte Wave',
    en: 'Wave Account Details'
  },
  'accountLinking.merchantAssociation': {
    fr: 'Association du marchand',
    en: 'Merchant Association'
  },
  'accountLinking.bankAccountId': {
    fr: 'ID du compte bancaire',
    en: 'Bank Account ID'
  },
  'accountLinking.waveAccountId': {
    fr: 'ID du compte Wave',
    en: 'Wave Account ID'
  },
  'accountLinking.continue': {
    fr: 'Continuer',
    en: 'Continue'
  },
  'accountLinking.back': {
    fr: 'Retour',
    en: 'Back'
  },
  'accountLinking.createLink': {
    fr: 'Créer le lien',
    en: 'Create Link'
  },

  // Loan History
  'loanHistory.title': {
    fr: 'Historique des prêts d\'un an',
    en: 'One-Year Loan History'
  },
  'loanHistory.totalApplications': {
    fr: 'Total des demandes',
    en: 'Total Applications'
  },
  'loanHistory.disbursedLoans': {
    fr: 'Prêts décaissés',
    en: 'Disbursed Loans'
  },
  'loanHistory.rejectedLoans': {
    fr: 'Prêts rejetés',
    en: 'Rejected Loans'
  },
  'loanHistory.totalDisbursed': {
    fr: 'Total décaissé',
    en: 'Total Disbursed'
  },
  'loanHistory.startDate': {
    fr: 'Date de début',
    en: 'Start Date'
  },
  'loanHistory.endDate': {
    fr: 'Date de fin',
    en: 'End Date'
  },
  'loanHistory.status': {
    fr: 'Statut',
    en: 'Status'
  },
  'loanHistory.customerType': {
    fr: 'Type de client',
    en: 'Customer Type'
  },
  'loanHistory.allStatuses': {
    fr: 'Tous les statuts',
    en: 'All Statuses'
  },
  'loanHistory.allTypes': {
    fr: 'Tous les types',
    en: 'All Types'
  },
  'loanHistory.individual': {
    fr: 'Individuel',
    en: 'Individual'
  },
  'loanHistory.sme': {
    fr: 'PME',
    en: 'SME'
  },
  'loanHistory.overview': {
    fr: 'Aperçu',
    en: 'Overview'
  },
  'loanHistory.loanDetails': {
    fr: 'Détails des prêts',
    en: 'Loan Details'
  },
  'loanHistory.repaymentHistory': {
    fr: 'Historique des remboursements',
    en: 'Repayment History'
  },
  'loanHistory.transactionHistory': {
    fr: 'Historique des transactions',
    en: 'Transaction History'
  },
  'loanHistory.monthlyTrends': {
    fr: 'Tendances mensuelles',
    en: 'Monthly Trends'
  },
  'loanHistory.monthlyDisbursements': {
    fr: 'Décaissements mensuels',
    en: 'Monthly Disbursements'
  },
  'loanHistory.applications': {
    fr: 'Demandes',
    en: 'Applications'
  },
  'loanHistory.exportXLS': {
    fr: 'Exporter XLS',
    en: 'Export XLS'
  },
  'loanHistory.exportPDF': {
    fr: 'Exporter PDF',
    en: 'Export PDF'
  },
  'loanHistory.loanId': {
    fr: 'ID du prêt',
    en: 'Loan ID'
  },
  'loanHistory.applicant': {
    fr: 'Demandeur',
    en: 'Applicant'
  },
  'loanHistory.type': {
    fr: 'Type',
    en: 'Type'
  },
  'loanHistory.amount': {
    fr: 'Montant',
    en: 'Amount'
  },
  'loanHistory.creditScore': {
    fr: 'Score de crédit',
    en: 'Credit Score'
  },
  'loanHistory.submissionDate': {
    fr: 'Date de soumission',
    en: 'Submission Date'
  },
  'loanHistory.interestRate': {
    fr: 'Taux d\'intérêt',
    en: 'Interest Rate'
  },
  'loanHistory.installment': {
    fr: 'Échéance',
    en: 'Installment'
  },
  'loanHistory.dueDate': {
    fr: 'Date d\'échéance',
    en: 'Due Date'
  },
  'loanHistory.principal': {
    fr: 'Principal',
    en: 'Principal'
  },
  'loanHistory.interest': {
    fr: 'Intérêt',
    en: 'Interest'
  },
  'loanHistory.remainingBalance': {
    fr: 'Solde restant',
    en: 'Remaining Balance'
  },
  'loanHistory.transactionId': {
    fr: 'ID de transaction',
    en: 'Transaction ID'
  },
  'loanHistory.date': {
    fr: 'Date',
    en: 'Date'
  },
  'loanHistory.reference': {
    fr: 'Référence',
    en: 'Reference'
  },

  // Additional Report Tabs
  'reports.portfolioHealth': {
    fr: 'Santé du portefeuille',
    en: 'Portfolio Health'
  },
  'reports.transactionReports': {
    fr: 'Rapports de transactions',
    en: 'Transaction Reports'
  },
  'reports.inactiveAlerts': {
    fr: 'Alertes inactives',
    en: 'Inactive Alerts'
  },
  'reports.accountLinking': {
    fr: 'Liaison de comptes',
    en: 'Account Linking'
  },
  'reports.loanHistory': {
    fr: 'Historique des prêts',
    en: 'Loan History'
  },
  'reports.regulatoryReports': {
    fr: 'Rapports réglementaires',
    en: 'Regulatory Reports'
  },
  'reports.kycReports': {
    fr: 'Rapports KYC',
    en: 'KYC Reports'
  },
  'reports.advancedRisk': {
    fr: 'Tableau de bord des risques avancés',
    en: 'Advanced Risk Dashboard'
  },

  // Regulatory Reports
  'regulatoryReports.title': {
    fr: 'Rapports réglementaires et de conformité',
    en: 'Regulatory & Compliance Reports'
  },
  'regulatoryReports.overallScore': {
    fr: 'Score de conformité global',
    en: 'Overall Compliance Score'
  },
  'regulatoryReports.complianceLevel': {
    fr: 'Niveau de conformité',
    en: 'Compliance Level'
  },
  'regulatoryReports.totalReports': {
    fr: 'Total des rapports',
    en: 'Total Reports'
  },
  'regulatoryReports.overallComplianceScore': {
    fr: 'Score de conformité global',
    en: 'Overall Compliance Score'
  },
  'regulatoryReports.activeReports': {
    fr: 'Rapports actifs',
    en: 'Active Reports'
  },
  'regulatoryReports.compliantMetrics': {
    fr: 'Métriques conformes',
    en: 'Compliant Metrics'
  },
  'regulatoryReports.nextReview': {
    fr: 'Prochaine révision',
    en: 'Next Review'
  },
  'regulatoryReports.period': {
    fr: 'Période',
    en: 'Period'
  },
  'regulatoryReports.regulator': {
    fr: 'Régulateur',
    en: 'Regulator'
  },
  'regulatoryReports.complianceTrends': {
    fr: 'Tendances de conformité',
    en: 'Compliance Trends'
  },
  'regulatoryReports.riskDistribution': {
    fr: 'Distribution des risques',
    en: 'Risk Distribution'
  },
  'regulatoryReports.complianceScore': {
    fr: 'Score de conformité',
    en: 'Compliance Score'
  },
  'regulatoryReports.regulatoryReports': {
    fr: 'Rapports réglementaires',
    en: 'Regulatory Reports'
  },
  'regulatoryReports.reportId': {
    fr: 'ID du rapport',
    en: 'Report ID'
  },
  'regulatoryReports.type': {
    fr: 'Type',
    en: 'Type'
  },
  'regulatoryReports.status': {
    fr: 'Statut',
    en: 'Status'
  },
  'regulatoryReports.riskLevel': {
    fr: 'Niveau de risque',
    en: 'Risk Level'
  },
  'regulatoryReports.actions': {
    fr: 'Actions',
    en: 'Actions'
  },
  'regulatoryReports.exportAll': {
    fr: 'Exporter tout',
    en: 'Export All'
  },
  'regulatoryReports.actualScore': {
    fr: 'Score réel',
    en: 'Actual Score'
  },
  'regulatoryReports.targetScore': {
    fr: 'Score cible',
    en: 'Target Score'
  },
  'regulatoryReports.reportType': {
    fr: 'Type de rapport',
    en: 'Report Type'
  },
  'regulatoryReports.view': {
    fr: 'Voir',
    en: 'View'
  },
  'regulatoryReports.download': {
    fr: 'Télécharger',
    en: 'Download'
  },
  'regulatoryReports.viewDetails': {
    fr: 'Voir les détails',
    en: 'View Details'
  },
  'regulatoryReports.reportDetails': {
    fr: 'Détails du rapport',
    en: 'Report Details'
  },
  'regulatoryReports.close': {
    fr: 'Fermer',
    en: 'Close'
  },
  'regulatoryReports.viewFullReport': {
    fr: 'Voir le rapport complet',
    en: 'View Full Report'
  },
  'regulatoryReports.comments': {
    fr: 'Commentaires',
    en: 'Comments'
  },
  'regulatoryReports.downloadReport': {
    fr: 'Télécharger le rapport',
    en: 'Download Report'
  },
  'regulatoryReports.complianceMetrics': {
    fr: 'Métriques de conformité',
    en: 'Compliance Metrics'
  },
  'regulatoryReports.category': {
    fr: 'Catégorie',
    en: 'Category'
  },
  'regulatoryReports.metric': {
    fr: 'Métrique',
    en: 'Metric'
  },
  'regulatoryReports.currentValue': {
    fr: 'Valeur actuelle',
    en: 'Current Value'
  },
  'regulatoryReports.targetValue': {
    fr: 'Valeur cible',
    en: 'Target Value'
  },
  'regulatoryReports.trend': {
    fr: 'Tendance',
    en: 'Trend'
  },
  'regulatoryReports.lastUpdated': {
    fr: 'Dernière mise à jour',
    en: 'Last Updated'
  },
  'regulatoryReports.detailedReportView': {
    fr: 'Vue détaillée des rapports',
    en: 'Detailed Report View'
  },
  'regulatoryReports.findings': {
    fr: 'Constats',
    en: 'Findings'
  },
  'regulatoryReports.recommendations': {
    fr: 'Recommandations',
    en: 'Recommendations'
  },
  'regulatoryReports.auditLog': {
    fr: 'Journal d\'audit',
    en: 'Audit Log'
  },
  'regulatoryReports.timestamp': {
    fr: 'Horodatage',
    en: 'Timestamp'
  },
  'regulatoryReports.action': {
    fr: 'Action',
    en: 'Action'
  },
  'regulatoryReports.user': {
    fr: 'Utilisateur',
    en: 'User'
  },
  'regulatoryReports.details': {
    fr: 'Détails',
    en: 'Details'
  },
  'regulatoryReports.complianceImpact': {
    fr: 'Impact sur la conformité',
    en: 'Compliance Impact'
  },
  'regulatoryReports.regulatoryRelevance': {
    fr: 'Pertinence réglementaire',
    en: 'Regulatory Relevance'
  },
  'regulatoryReports.monthly': {
    fr: 'Mensuel',
    en: 'Monthly'
  },
  'regulatoryReports.quarterly': {
    fr: 'Trimestriel',
    en: 'Quarterly'
  },
  'regulatoryReports.annual': {
    fr: 'Annuel',
    en: 'Annual'
  },
  'regulatoryReports.adHoc': {
    fr: 'Ad hoc',
    en: 'Ad-hoc'
  },
  'regulatoryReports.draft': {
    fr: 'Brouillon',
    en: 'Draft'
  },
  'regulatoryReports.submitted': {
    fr: 'Soumis',
    en: 'Submitted'
  },
  'regulatoryReports.approved': {
    fr: 'Approuvé',
    en: 'Approved'
  },
  'regulatoryReports.rejected': {
    fr: 'Rejeté',
    en: 'Rejected'
  },
  'regulatoryReports.compliant': {
    fr: 'Conforme',
    en: 'Compliant'
  },
  'regulatoryReports.nonCompliant': {
    fr: 'Non conforme',
    en: 'Non-Compliant'
  },
  'regulatoryReports.atRisk': {
    fr: 'À risque',
    en: 'At-Risk'
  },
  'regulatoryReports.lowRisk': {
    fr: 'Risque faible',
    en: 'Low Risk'
  },
  'regulatoryReports.mediumRisk': {
    fr: 'Risque moyen',
    en: 'Medium Risk'
  },
  'regulatoryReports.highRisk': {
    fr: 'Risque élevé',
    en: 'High Risk'
  },
  'regulatoryReports.criticalRisk': {
    fr: 'Risque critique',
    en: 'Critical Risk'
  },
  'regulatoryReports.improving': {
    fr: 'Amélioration',
    en: 'Improving'
  },
  'regulatoryReports.stable': {
    fr: 'Stable',
    en: 'Stable'
  },
  'regulatoryReports.declining': {
    fr: 'Déclin',
    en: 'Declining'
  },
  'regulatoryReports.lowImpact': {
    fr: 'Impact faible',
    en: 'Low Impact'
  },
  'regulatoryReports.mediumImpact': {
    fr: 'Impact moyen',
    en: 'Medium Impact'
  },
  'regulatoryReports.highImpact': {
    fr: 'Impact élevé',
    en: 'High Impact'
  },
  'regulatoryReports.statuses': {
    fr: 'Statuts',
    en: 'Statuses'
  },
  'regulatoryReports.statuses.draft': {
    fr: 'Brouillon',
    en: 'Draft'
  },
  'regulatoryReports.statuses.submitted': {
    fr: 'Soumis',
    en: 'Submitted'
  },
  'regulatoryReports.statuses.approved': {
    fr: 'Approuvé',
    en: 'Approved'
  },
  'regulatoryReports.statuses.rejected': {
    fr: 'Rejeté',
    en: 'Rejected'
  },
  'regulatoryReports.statuses.compliant': {
    fr: 'Conforme',
    en: 'Compliant'
  },
  'regulatoryReports.statuses.nonCompliant': {
    fr: 'Non conforme',
    en: 'Non-Compliant'
  },
  'regulatoryReports.statuses.warning': {
    fr: 'Avertissement',
    en: 'Warning'
  },
  'regulatoryReports.statuses.success': {
    fr: 'Succès',
    en: 'Success'
  },
  'regulatoryReports.statuses.failure': {
    fr: 'Échec',
    en: 'Failure'
  },
  'regulatoryReports.riskLevels': {
    fr: 'Niveaux de risque',
    en: 'Risk Levels'
  },
  'regulatoryReports.riskLevels.low': {
    fr: 'Risque faible',
    en: 'Low Risk'
  },
  'regulatoryReports.riskLevels.medium': {
    fr: 'Risque moyen',
    en: 'Medium Risk'
  },
  'regulatoryReports.riskLevels.high': {
    fr: 'Risque élevé',
    en: 'High Risk'
  },
  'regulatoryReports.outOfTotal': {
    fr: 'sur {total}',
    en: 'out of {total}'
  },

  // Settings Page
  'settings.title': {
    fr: 'Paramètres',
    en: 'Settings'
  },
  'settings.subtitle': {
    fr: 'Gérez vos préférences de compte et la configuration du système',
    en: 'Manage your account preferences and system configuration'
  },
  'settings.userProfile': {
    fr: 'Profil utilisateur',
    en: 'User Profile'
  },
  'settings.systemPreferences': {
    fr: 'Préférences système',
    en: 'System Preferences'
  },
  'settings.bridgeBankGroup': {
    fr: 'FinScore AI Platform',
    en: 'FinScore AI Platform'
  },
  'settings.email': {
    fr: 'E-mail',
    en: 'Email'
  },
  'settings.role': {
    fr: 'Rôle',
    en: 'Role'
  },
  'settings.merchantId': {
    fr: 'ID du marchand',
    en: 'Merchant ID'
  },
  'settings.updateProfile': {
    fr: 'Mettre à jour le profil',
    en: 'Update Profile'
  },
  'settings.emailNotifications': {
    fr: 'Notifications par e-mail',
    en: 'Email Notifications'
  },
  'settings.smsAlerts': {
    fr: 'Alertes SMS',
    en: 'SMS Alerts'
  },
  'settings.weeklyReports': {
    fr: 'Rapports hebdomadaires',
    en: 'Weekly Reports'
  },
  'settings.riskAlerts': {
    fr: 'Alertes de risque',
    en: 'Risk Alerts'
  },
  'settings.languageInfo': {
    fr: 'Langue : Anglais (Devise ZiG)',
    en: 'Language: English (ZiG Currency)'
  },
  'settings.timezoneInfo': {
    fr: 'Fuseau horaire : GMT+2 (Zimbabwe)',
    en: 'Timezone: GMT+2 (Zimbabwe)'
  },
  'settings.changePassword': {
    fr: 'Changer le mot de passe',
    en: 'Change Password'
  },
  'settings.enable2FA': {
    fr: 'Activer l\'authentification à deux facteurs',
    en: 'Enable 2FA'
  },
  'settings.sessionTimeout': {
    fr: 'Délai d\'expiration de session (30 min)',
    en: 'Session Timeout (30 min)'
  },
  'settings.lastLogin': {
    fr: 'Dernière connexion',
    en: 'Last login'
  },
  'settings.institution': {
    fr: 'Institution',
    en: 'Institution'
  },
  'settings.system': {
    fr: 'Système',
    en: 'System'
  },
  'settings.region': {
    fr: 'Région',
    en: 'Region'
  },
  'settings.contactSupport': {
    fr: 'Contacter le support',
    en: 'Contact Support'
  },
  'settings.creditScoringEngine': {
    fr: 'Moteur de scoring de crédit v2.0',
    en: 'Credit Scoring Engine v2.0'
  },
  'settings.westAfricanCFA': {
    fr: 'Zimbabwe Gold (ZiG)',
    en: 'Zimbabwe Gold (ZiG)'
  },
  'settings.westAfrica': {
    fr: 'Zimbabwe',
    en: 'Zimbabwe'
  },

  // Login Page
  'login.creditScoringEngine': {
    fr: 'Moteur de scoring de crédit',
    en: 'Credit Scoring Engine'
  },
  'login.bridgeBankPortal': {
    fr: 'Portail Administrateur',
    en: 'Admin Portal'
  },
  'login.wavePortal': {
    fr: 'Portail WAVE',
    en: 'WAVE Portal'
  },
  'login.merchantPortal': {
    fr: 'Portail Marchand',
    en: 'Merchant Portal'
  },
  'login.bridgeBankAccess': {
    fr: 'Accès Administrateur',
    en: 'Admin Access'
  },
  'login.waveAccess': {
    fr: 'Accès WAVE',
    en: 'WAVE Access'
  },
  'login.merchantAccess': {
    fr: 'Accès Marchand',
    en: 'Merchant Access'
  },
  'login.emailAddress': {
    fr: 'Adresse e-mail',
    en: 'Email Address'
  },
  'login.password': {
    fr: 'Mot de passe',
    en: 'Password'
  },
  'login.signIn': {
    fr: 'Se connecter',
    en: 'Sign In'
  },
  'login.forgotPassword': {
    fr: 'Mot de passe oublié ?',
    en: 'Forgot password?'
  },

  // Loan Application Form
  'loanForm.title': {
    fr: 'Demande de prêt',
    en: 'Loan Application'
  },
  'loanForm.customerType': {
    fr: 'Type de client',
    en: 'Customer Type'
  },
  'loanForm.individual': {
    fr: 'Individuel',
    en: 'Individual'
  },
  'loanForm.sme': {
    fr: 'PME',
    en: 'SME'
  },
  'loanForm.businessName': {
    fr: 'Nom de l\'entreprise',
    en: 'Business Name'
  },
  'loanForm.businessType': {
    fr: 'Type d\'entreprise',
    en: 'Business Type'
  },
  'loanForm.yearsInBusiness': {
    fr: 'Années d\'activité',
    en: 'Years in Business'
  },
  'loanForm.fullName': {
    fr: 'Nom complet / Nom du propriétaire',
    en: 'Full Name / Proprietor Name'
  },
  'loanForm.email': {
    fr: 'E-mail',
    en: 'Email'
  },
  'loanForm.phoneNumber': {
    fr: 'Numéro de téléphone',
    en: 'Phone Number'
  },
  'loanForm.nationalId': {
    fr: 'Identifiant national',
    en: 'National ID'
  },
  'loanForm.monthlyIncome': {
    fr: 'Revenu mensuel (ZiG)',
    en: 'Monthly Income (ZiG)'
  },
  'loanForm.requestedAmount': {
    fr: 'Montant de prêt demandé (ZiG)',
    en: 'Requested Loan Amount (ZiG)'
  },
  'loanForm.employmentStatus': {
    fr: 'Statut d\'emploi',
    en: 'Employment Status'
  },
  'loanForm.employed': {
    fr: 'Employé',
    en: 'Employed'
  },
  'loanForm.selfEmployed': {
    fr: 'Travailleur indépendant',
    en: 'Self Employed'
  },
  'loanForm.businessOwner': {
    fr: 'Propriétaire d\'entreprise',
    en: 'Business Owner'
  },
  'loanForm.unemployed': {
    fr: 'Chômeur',
    en: 'Unemployed'
  },
  'loanForm.employmentDuration': {
    fr: 'Durée d\'emploi (années)',
    en: 'Employment Duration (years)'
  },
  'loanForm.age': {
    fr: 'Âge',
    en: 'Age'
  },
  'loanForm.existingLoans': {
    fr: 'Nombre de prêts existants',
    en: 'Number of Existing Loans'
  },
  'loanForm.supportingDocuments': {
    fr: 'Documents de support (optionnel)',
    en: 'Supporting Documents (Optional)'
  },
  'loanForm.uploadBankStatement': {
    fr: 'Télécharger le relevé bancaire',
    en: 'Upload Bank Statement'
  },
  'loanForm.uploadCreditCardStatement': {
    fr: 'Télécharger le relevé de carte de crédit',
    en: 'Upload Credit Card Statement'
  },
  'loanForm.uploadTelephoneBill': {
    fr: 'Télécharger la facture de téléphone',
    en: 'Upload Telephone Bill'
  },
  'loanForm.uploadLoanStatements': {
    fr: 'Télécharger les relevés de prêt',
    en: 'Upload Loan Statements'
  },
  'loanForm.uploadAddressProof': {
    fr: 'Télécharger la preuve d\'adresse',
    en: 'Upload Address Proof'
  },
  'loanForm.uploadBusinessRegistration': {
    fr: 'Télécharger l\'enregistrement d\'entreprise',
    en: 'Upload Business Registration'
  },
  'loanForm.uploadFinancialStatements': {
    fr: 'Télécharger les états financiers',
    en: 'Upload Financial Statements'
  },
  'loanForm.submitApplication': {
    fr: 'Soumettre la demande',
    en: 'Submit Application'
  },
  'loanForm.applicationSubmitted': {
    fr: 'Demande soumise avec succès !',
    en: 'Application submitted successfully!'
  },
  'loanForm.required': {
    fr: 'Requis',
    en: 'Required'
  },
  'loanForm.requiredForIndividuals': {
    fr: 'Requis pour les particuliers',
    en: 'Required for Individuals'
  },
  'loanForm.requiredForSMEs': {
    fr: 'Requis pour les PME',
    en: 'Required for SMEs'
  },
  'loanForm.invalidEmail': {
    fr: 'E-mail invalide',
    en: 'Invalid email'
  },
  'loanForm.minimumMonthlyIncome': {
    fr: 'Le revenu mensuel minimum est de ZiG {amount}',
    en: 'Minimum monthly income is ZiG {amount}'
  },
  'loanForm.minimumLoanAmount': {
    fr: 'Le montant minimum du prêt est de ZiG {amount}',
    en: 'Minimum loan amount is ZiG {amount}'
  },
  'loanForm.maximumLoanAmount': {
    fr: 'Le montant maximum du prêt est de ZiG {amount}',
    en: 'Maximum loan amount is ZiG {amount}'
  },
  'loanForm.mustBe18': {
    fr: 'Doit avoir au moins 18 ans',
    en: 'Must be at least 18 years old'
  },

  // Advanced Risk Dashboard
  'advancedRisk.fraudulentActivity': {
    fr: 'Activité frauduleuse détectée - Demande rejetée',
    en: 'Fraudulent activity detected - Application rejected'
  },
  'advancedRisk.noFraudDetected': {
    fr: 'Aucune fraude détectée - Demande approuvée',
    en: 'No fraud detected - Application approved'
  },
  'advancedRisk.riskLevel': {
    fr: 'Niveau de risque',
    en: 'Risk Level'
  },
  'advancedRisk.confidence': {
    fr: 'Confiance',
    en: 'Confidence'
  },
  'advancedRisk.action': {
    fr: 'Action',
    en: 'Action'
  },
  'advancedRisk.fraudIndicators': {
    fr: 'Indicateurs de fraude',
    en: 'Fraud Indicators'
  },
  'advancedRisk.approve': {
    fr: 'Approuver',
    en: 'Approve'
  },
  'advancedRisk.reject': {
    fr: 'Rejeter',
    en: 'Reject'
  },

  // Rules Management
  'rules.title': {
    fr: 'Gestion des règles',
    en: 'Rules Management'
  },
  'rules.individualRules': {
    fr: 'Règles individuelles',
    en: 'Individual Rules'
  },
  'rules.smeRules': {
    fr: 'Règles PME',
    en: 'SME Rules'
  },
  'rules.addRule': {
    fr: 'Ajouter une règle',
    en: 'Add Rule'
  },
  'rules.ruleName': {
    fr: 'Nom de la règle',
    en: 'Rule Name'
  },
  'rules.description': {
    fr: 'Description',
    en: 'Description'
  },
  'rules.field': {
    fr: 'Champ',
    en: 'Field'
  },
  'rules.operator': {
    fr: 'Opérateur',
    en: 'Operator'
  },
  'rules.value': {
    fr: 'Valeur',
    en: 'Value'
  },
  'rules.score': {
    fr: 'Score',
    en: 'Score'
  },
  'rules.actions': {
    fr: 'Actions',
    en: 'Actions'
  },
  'rules.edit': {
    fr: 'Modifier',
    en: 'Edit'
  },
  'rules.delete': {
    fr: 'Supprimer',
    en: 'Delete'
  },
  'rules.save': {
    fr: 'Enregistrer',
    en: 'Save'
  },
  'rules.cancel': {
    fr: 'Annuler',
    en: 'Cancel'
  },

  // Application List
  'applicationList.searchByName': {
    fr: 'Rechercher par nom',
    en: 'Search by Name'
  },
  'applicationList.searchByNationalId': {
    fr: 'Rechercher par ID national',
    en: 'Search by National ID'
  },
  'applicationList.status': {
    fr: 'Statut',
    en: 'Status'
  },
  'applicationList.customerType': {
    fr: 'Type de client',
    en: 'Customer Type'
  },
  'applicationList.title': {
    fr: 'Demandes de prêt',
    en: 'Loan Applications'
  },
  'applicationList.applicantName': {
    fr: 'Nom du demandeur',
    en: 'Applicant Name'
  },
  'applicationList.email': {
    fr: 'E-mail',
    en: 'Email'
  },
  'applicationList.amountRequested': {
    fr: 'Montant demandé',
    en: 'Amount Requested'
  },
  'applicationList.score': {
    fr: 'Score',
    en: 'Score'
  },
  'applicationList.interestRate': {
    fr: 'Taux d\'intérêt',
    en: 'Interest Rate'
  },
  'applicationList.all': {
    fr: 'Tous',
    en: 'All'
  },

  // Transaction Details
  'transactionDetails.filters': {
    fr: 'Filtres',
    en: 'Filters'
  },
  'transactionDetails.merchantId': {
    fr: 'ID du marchand',
    en: 'Merchant ID'
  },
  'transactionDetails.startDate': {
    fr: 'Date de début',
    en: 'Start Date'
  },
  'transactionDetails.endDate': {
    fr: 'Date de fin',
    en: 'End Date'
  },

  // Reports Page
  'reports.downloadLoanApplications': {
    fr: 'Télécharger les demandes de prêt',
    en: 'Download Loan Applications'
  },
  'reports.filterByStatus': {
    fr: 'Filtrer par statut',
    en: 'Filter by Status'
  },
  'reports.downloadXLS': {
    fr: 'Télécharger XLS',
    en: 'Download XLS'
  },
  'reports.downloadPDF': {
    fr: 'Télécharger PDF',
    en: 'Download PDF'
  },
  'reports.all': {
    fr: 'Tous',
    en: 'All'
  },
  'reports.pending': {
    fr: 'En attente',
    en: 'Pending'
  },
  'reports.approved': {
    fr: 'Approuvées',
    en: 'Approved'
  },
  'reports.rejected': {
    fr: 'Rejetées',
    en: 'Rejected'
  },
  'reports.auditLog': {
    fr: 'Journal d\'audit',
    en: 'Audit Log'
  },
  'reports.timestamp': {
    fr: 'Horodatage',
    en: 'Timestamp'
  },
  'reports.user': {
    fr: 'Utilisateur',
    en: 'User'
  },
  'reports.action': {
    fr: 'Action',
    en: 'Action'
  },
  'reports.details': {
    fr: 'Détails',
    en: 'Details'
  },
  'reports.rules': {
    fr: 'Règles',
    en: 'Rules'
  },
  'reports.name': {
    fr: 'Nom',
    en: 'Name'
  },
  'reports.description': {
    fr: 'Description',
    en: 'Description'
  },
  'reports.field': {
    fr: 'Champ',
    en: 'Field'
  },
  'reports.operator': {
    fr: 'Opérateur',
    en: 'Operator'
  },
  'reports.value': {
    fr: 'Valeur',
    en: 'Value'
  },
  'reports.score': {
    fr: 'Score',
    en: 'Score'
  },
  'reports.downloadAuditLog': {
    fr: 'Télécharger le journal d\'audit',
    en: 'Download Audit Log'
  },
  'reports.downloadRules': {
    fr: 'Télécharger les règles',
    en: 'Download Rules'
  },

  // Application Detail
  'applicationDetail.applicantInformation': {
    fr: 'Informations du demandeur',
    en: 'Applicant Information'
  },
  'applicationDetail.uploadedDocuments': {
    fr: 'Documents téléchargés',
    en: 'Uploaded Documents'
  },
  'applicationDetail.scoringResult': {
    fr: 'Résultat du scoring',
    en: 'Scoring Result'
  },
  'applicationDetail.applicationNotFound': {
    fr: 'Demande non trouvée.',
    en: 'Application not found.'
  },

  // Advanced Risk Dashboard - Additional Keys
  'advancedRisk.title': {
    fr: 'Tableau de bord des risques avancés',
    en: 'Advanced Risk Dashboard'
  },
  'advancedRisk.finalCreditScore': {
    fr: 'Score de crédit final',
    en: 'Final Credit Score'
  },
  'advancedRisk.hybridScoringModel': {
    fr: 'Modèle de scoring hybride',
    en: 'Hybrid scoring model'
  },
  'advancedRisk.fraudRisk': {
    fr: 'Risque de fraude',
    en: 'Fraud Risk'
  },
  'advancedRisk.dataQualityScore': {
    fr: 'Score de qualité des données',
    en: 'Data quality score'
  },
  'advancedRisk.interestRate': {
    fr: 'Taux d\'intérêt',
    en: 'Interest Rate'
  },
  'advancedRisk.riskBasedPricing': {
    fr: 'Tarification basée sur le risque',
    en: 'Risk-based pricing'
  },
  'advancedRisk.fraudDetectionAnalysis': {
    fr: 'Analyse de détection de fraude',
    en: 'Fraud Detection Analysis'
  },

  // KYC Reports
  'kyc.reportPeriod': {
    fr: 'Période du rapport',
    en: 'Report Period'
  },
  'kyc.verified': {
    fr: 'Vérifié',
    en: 'Verified'
  },
  'kyc.pending': {
    fr: 'En attente',
    en: 'Pending'
  },
  'kyc.failed': {
    fr: 'Échoué',
    en: 'Failed'
  },

  // Portfolio Health
  'portfolio.performingLoans': {
    fr: 'Prêts performants',
    en: 'Performing Loans'
  },
  'portfolio.nonPerformingLoans': {
    fr: 'Prêts non performants',
    en: 'Non-Performing Loans'
  },

  // Merchant Categories
  'merchantCategory.RESTAURANT': {
    fr: 'Restaurant',
    en: 'Restaurant'
  },
  'merchantCategory.GROCERY': {
    fr: 'Épicerie',
    en: 'Grocery'
  },
  'merchantCategory.MULTISERVICE': {
    fr: 'Multiservice',
    en: 'Multiservice'
  },
  'merchantCategory.FABRIC_CLOTHES': {
    fr: 'Textile/Vêtements',
    en: 'Fabric/Clothes'
  },
  'merchantCategory.BOUTIQUE': {
    fr: 'Boutique',
    en: 'Boutique'
  },
  'merchantCategory.OTHER': {
    fr: 'Autre',
    en: 'Other'
  },
  'merchantCategory.ELECTRONICS': {
    fr: 'Électronique',
    en: 'Electronics'
  },
  'merchantCategory.HOME_SUPPLIES_DECOR': {
    fr: 'Fournitures/Décoration',
    en: 'Home Supplies/Decor'
  },
  'merchantCategory.ALCOHOL_TOBACCO': {
    fr: 'Alcool/Tabac',
    en: 'Alcohol/Tobacco'
  },
  'nav.usersManagement': {
    fr: 'Gestion des utilisateurs',
    en: 'Users Management'
  },
  // Users Management
  'users.title': {
    fr: 'Gestion des utilisateurs',
    en: 'Users Management'
  },
  'users.addUser': {
    fr: 'Ajouter un utilisateur',
    en: 'Add User'
  },
  'users.editUser': {
    fr: 'Modifier l\'utilisateur',
    en: 'Edit User'
  },
  'users.privileges': {
    fr: 'Privilèges',
    en: 'Privileges'
  },
  'nav.notifications': { fr: 'Notifications', en: 'Notifications' },
  // Notifications Center
  'notifications.title': { fr: 'Centre de notifications', en: 'Notifications Center' },
  'notifications.new': { fr: 'Nouvelle notification', en: 'New Notification' },
  'notifications.channel': { fr: 'Canal', en: 'Channel' },
  'notifications.template': { fr: 'Modèle', en: 'Template' },
  'notifications.custom': { fr: 'Personnalisé', en: 'Custom' },
  'notifications.subject': { fr: 'Sujet', en: 'Subject' },
  'notifications.message': { fr: 'Message', en: 'Message' },
  'notifications.audience': { fr: 'Audience cible', en: 'Target Audience' },
  'notifications.send': { fr: 'Envoyer', en: 'Send' },
  'notifications.noSubject': { fr: 'Sans sujet', en: 'No subject' },
  'notifications.scheduleAt': { fr: 'Programmer à', en: 'Schedule At' },
  'notifications.preview': { fr: 'Prévisualiser', en: 'Preview' },
  'notifications.estimatedRecipients': { fr: '{n} destinataires estimés', en: '{n} estimated recipients' }
};
